// suppressResizeObserverError.js
// =============================================================================
// "ResizeObserver loop completed with undelivered notifications" è un warning
// BENIGNO del browser (un callback RO causa un re-layout nello stesso frame).
// In sviluppo l'overlay errori di CRA lo mostra come errore rosso a tutto schermo.
// Questo modulo lo neutralizza in tre modi (va importato PER PRIMO in index.js):
//   1) Deferisce i callback di ResizeObserver di un frame → il loop sincrono non
//      si genera più (elimina la causa alla radice).
//   2) Filtra il messaggio da console.error.
//   3) Intercetta l'evento 'error' e rimuove l'eventuale overlay di CRA.
// Sicuro anche in produzione (in build l'overlay non esiste comunque).
// =============================================================================

const RO_MESSAGES = [
  'ResizeObserver loop completed with undelivered notifications',
  'ResizeObserver loop limit exceeded',
];
const isRoMessage = (m) => typeof m === 'string' && RO_MESSAGES.some((x) => m.indexOf(x) !== -1);

if (typeof window !== 'undefined') {
  // 1) Defer dei callback ResizeObserver (rompe il loop sincrono alla sorgente)
  if (typeof window.ResizeObserver === 'function' && !window.__roPatched) {
    const NativeResizeObserver = window.ResizeObserver;
    window.ResizeObserver = class extends NativeResizeObserver {
      constructor(callback) {
        let rafId = 0;
        super((entries, observer) => {
          if (rafId) cancelAnimationFrame(rafId);
          rafId = requestAnimationFrame(() => {
            rafId = 0;
            try { callback(entries, observer); } catch (_) { /* noop */ }
          });
        });
      }
    };
    window.__roPatched = true;
  }

  // 2) Filtra il warning da console.error (lo usa anche l'overlay per intercettarlo)
  if (window.console && typeof window.console.error === 'function' && !window.__roConsolePatched) {
    const orig = window.console.error.bind(window.console);
    window.console.error = (...args) => {
      if (args.length && isRoMessage(args[0])) return;
      return orig(...args);
    };
    window.__roConsolePatched = true;
  }

  // 3) Belt-and-suspenders: ferma l'evento 'error' e rimuove l'overlay CRA
  const removeCraOverlay = () => {
    try {
      document.querySelectorAll('body > iframe').forEach((f) => {
        const z = f.style && f.style.zIndex;
        if (z === '2147483647') f.remove(); // iframe di react-error-overlay
      });
      const wds = document.getElementById('webpack-dev-server-client-overlay');
      if (wds) wds.remove();
    } catch (_) { /* noop */ }
  };
  window.addEventListener('error', (event) => {
    if (isRoMessage(event && event.message)) {
      event.stopImmediatePropagation();
      event.preventDefault();
      setTimeout(removeCraOverlay, 0);
    }
  }, true);
  window.addEventListener('unhandledrejection', (event) => {
    const msg = (event && event.reason && event.reason.message) || String((event && event.reason) || '');
    if (isRoMessage(msg)) { event.preventDefault(); setTimeout(removeCraOverlay, 0); }
  });
}
